export const NORMAL_NODE_INDEX_START = 'NORMAL_NODE_INDEX_START';
export const NORMAL_NODE_INDEX_SUCCESS = 'NORMAL_NODE_INDEX_SUCCESS';
export const NORMAL_NODE_INDEX_FAILURE = 'NORMAL_NODE_INDEX_FAILURE';
export const SIMPLE_NODE_INDEX_START = 'SIMPLE_NODE_INDEX_START';
export const SIMPLE_NODE_INDEX_SUCCESS = 'SIMPLE_NODE_INDEX_SUCCESS';
export const SIMPLE_NODE_INDEX_FAILURE = 'SIMPLE_NODE_INDEX_FAILURE';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
